import src from "IMAGE";
export default { src, width: 443, height: 525, blurWidth: 0, blurHeight: 0};
